module.exports = __webpack_public_path__ + "static/media/jongseo-park-new.ffb5906c.png";